import * as constants from "./constants";

export function setLoginConfirm(val, url, query) {
  return {
    type: constants.SET_LOGIN_CONFIRM,
    payload: {
      showConfirm: val,
      url,
      query,
    },
  };
}
